export enum ComptageType {
  inventaire = 1,
  preparation = 2,
  reception = 2
}
